import React from "react";

export const TableHead = (props) => {
  return (
    <tr>
      <th style={{ width: "25%" }} className="table-style">Offers/<br />Offer Type</th>
      {/* <th style={{ width: "
      " }} className="table-style"><center>User</center></th> */}

      <th style={{ width: "140px" }} className="table-style">Available Date</th>
      <th style={{ width: "140px" }} className="table-style">Discount <br />Type</th>

      <th style={{ width: "140px" }} className="table-style">Discount <br/>Fixed Amount</th>
      <th style={{ width: "140px" }} className="table-style">Available on <br/>Services</th>
      <th style={{ width: "140px" }} className="table-style">Offer Code</th>
      <th style={{ width: "140px" }} className="table-style">Offer Used</th>
      {/* <th style={{ width: "150px" }} className="table-style">Offer View</th> */}
    </tr>
  );
};
